export const variables = {
  breakpoints: {
    sml: 480,
    med: 720,
    lrg: 960,
    xlg: 1200,
  },
};
